import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi There, I am <span className="purple">Jimmy Kihara Chege </span>
            from <span className="purple"> Nairobi, Kenya.</span>
            <br />
            I am currently pursueing Bachelor of Science in Software Engineering at Zetech University,Kenya.
            About Web Developing, I am currently pursuing Fullstack Developoment at W3Schools.
            <br />
            I have completed Diploma in Cybersecurity and Forensics at the ICS college.
            I've also done Data Analytics at Alison Online Platform and i can say i am qualified in Data Analysis., 
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Video Games i.e FC25
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading motivational books
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling around
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">JimmTech</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
